<div class="container py-4 position-relative">
  <div class="row align-items-center mb-3">
    <!-- Left Column: Create Experiment Button -->
    <div class="col-md-6 position-relative">
      <button class="btn exp-create-btn" (click)="toggleOverlay()">
        Create Experiment
      </button>

      <!-- Conditionally render the popup -->
      <app-create-experiment
        *ngIf="showOverlay"
        (closed)="closeOverlay()"
      ></app-create-experiment>
    </div>

    <!-- Right Column: Search Bar -->
    <div class="col-md-6">
      <div class="search-container position-relative">
        <span
          class="search-icon position-absolute top-50 start-0 translate-middle-y ms-3"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001l3.85 3.85a1 1 0 0 0
             1.415-1.414l-3.867-3.834zM12 6.5a5.5 5.5 0 1
             1-11 0 5.5 5.5 0 0 1 11 0z"
            />
          </svg>
        </span>

        <input
          type="text"
          class="form-control ps-5"
          placeholder="Search by experiment name or user full name"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
        />
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between">
    <a
      class="nav-link w-50 me-1 mt-1"
      [ngClass]="{ active: filterMode === 'all' }"
      href="#"
      (click)="setFilterMode('all', $event)"
      >All Experiments</a
    >
    <a
      class="nav-link w-50 ms-1 mt-1"
      [ngClass]="{ active: filterMode === 'mine' }"
      href="#"
      (click)="setFilterMode('mine', $event)"
      >My Experiments</a
    >
  </div>

  <div class="content pt-2">
    <div *ngFor="let group of groupedItems | keyvalue: sortByDateDesc">
      <div class="mb-3">
        <!-- Toggle: Date -->
        <div
          class="date-toggle text-end mb-2"
          style="cursor: pointer"
          (click)="toggleCollapse(group.key)"
        >
          {{ group.key + "-01" | date: "MMMM yyyy" }}
        </div>

        <!-- Collapsible Content -->
        <div class="mt-2" [ngClass]="{ 'd-none': !collapseStates[group.key] }">
          <div
            *ngFor="let item of group.value"
            class="card mb-2 custom-card text-white"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center"
            >
              <div class="d-flex flex-column">
                <span class="fw-bold fs-5">{{ item.experiment }}</span>
                <small class="fw-bold fs-8">
                  Created by: {{ item.created_user }}
                </small>
              </div>

              <app-common-overlay
                *ngIf="showCommonOverlay"
                [actionType]="overlayMode"
                [selectedItem]="selectedItem"
                (closed)="closeCommonOverlay()"
              ></app-common-overlay>
              <div class="icon-group d-flex gap-2">
                <!-- Erase Button -->
                <button
                  class="btn action-btn"
                  title="Erase Results"
                  (click)="openCommonOverlay('erase', item)"
                  *ngIf="filterMode === 'mine'"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    fill="#000000"
                    height="20"
                    width="20"
                    version="1.1"
                    id="Capa_1"
                    viewBox="0 0 612.002 612.002"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        d="M594.464,534.414H344.219L606.866,271.77c6.848-6.851,6.848-17.953,0-24.8L407.547,47.65   c-3.291-3.288-7.749-5.135-12.401-5.135c-4.65,0-9.11,1.847-12.398,5.135L5.138,425.262c-6.851,6.848-6.851,17.95,0,24.8   l114.29,114.287c3.288,3.291,7.749,5.138,12.398,5.138h462.638c9.684,0,17.536-7.852,17.536-17.536   C612,542.265,604.148,534.414,594.464,534.414z M395.145,84.851L569.664,259.37L363.27,465.763L188.753,291.245L395.145,84.851z    M294.618,534.414H139.09L42.336,437.66l121.617-121.617l174.519,174.519L294.618,534.414z"
                      />
                    </g>
                  </svg>
                </button>

                <button
                  class="btn action-btn"
                  title="Delete Experiment"
                  (click)="openCommonOverlay('delete', item)"
                  *ngIf="filterMode === 'mine'"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="20"
                    height="20"
                    viewBox="0,0,256,256"
                    style="fill: #1a1a1a"
                  >
                    <g
                      fill="#1a1a1a"
                      fill-rule="nonzero"
                      stroke="none"
                      stroke-width="1"
                      stroke-linecap="butt"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                      stroke-dasharray=""
                      stroke-dashoffset="0"
                      font-family="none"
                      font-weight="none"
                      font-size="none"
                      text-anchor="none"
                      style="mix-blend-mode: normal"
                    >
                      <g transform="scale(8.53333,8.53333)">
                        <path
                          d="M14.98438,2.48633c-0.55152,0.00862 -0.99193,0.46214 -0.98437,1.01367v0.5h-5.5c-0.26757,-0.00363 -0.52543,0.10012 -0.71593,0.28805c-0.1905,0.18793 -0.29774,0.44436 -0.29774,0.71195h-1.48633c-0.36064,-0.0051 -0.69608,0.18438 -0.87789,0.49587c-0.18181,0.3115 -0.18181,0.69676 0,1.00825c0.18181,0.3115 0.51725,0.50097 0.87789,0.49587h18c0.36064,0.0051 0.69608,-0.18438 0.87789,-0.49587c0.18181,-0.3115 0.18181,-0.69676 0,-1.00825c-0.18181,-0.3115 -0.51725,-0.50097 -0.87789,-0.49587h-1.48633c0,-0.26759 -0.10724,-0.52403 -0.29774,-0.71195c-0.1905,-0.18793 -0.44836,-0.29168 -0.71593,-0.28805h-5.5v-0.5c0.0037,-0.2703 -0.10218,-0.53059 -0.29351,-0.72155c-0.19133,-0.19097 -0.45182,-0.29634 -0.72212,-0.29212zM6,9l1.79297,15.23438c0.118,1.007 0.97037,1.76563 1.98438,1.76563h10.44531c1.014,0 1.86538,-0.75862 1.98438,-1.76562l1.79297,-15.23437z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </button>

                <!-- Preview Button -->

                <button class="btn action-btn" title="Preview">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#000000"
                    class="bi bi-eye"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zm-8 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                    />
                    <path d="M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
                  </svg>
                </button>

                <!-- Copy Button -->
                <button
                  class="btn action-btn"
                  [ngClass]="
                    clipboardState === item.publish_link ? 'copied' : ''
                  "
                  (click)="copyToClipboard(item.publish_link, $event)"
                  title="Copy Link"
                >
                  <svg
                    *ngIf="clipboardState !== item.publish_link"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#000000"
                    class="bi bi-clipboard"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M10 1.5v1h3a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-11A.5.5 0 0 1 3 2.5h3v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5zM4 3v10h8V3H4z"
                    />
                  </svg>
                  <svg
                    *ngIf="clipboardState === item.publish_link"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#000000"
                    class="bi bi-clipboard-check"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10.854 6.146a.5.5 0 0 1 0 .708L7.707 10l-1.854-1.854a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                    />
                    <path
                      d="M10 1.5v1h3a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-11A.5.5 0 0 1 3 2.5h3v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5z"
                    />
                  </svg>
                </button>

                <!-- Download Button -->
                <button
                  class="btn action-btn"
                  title="Download Results"
                  (click)="downloadResults(item._id)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#000000"
                    class="bi bi-download"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M.5 9.9a.5.5 0 0 1 .5.5V14h14V10.4a.5.5 0 0 1 1 0v4.1a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V10.4a.5.5 0 0 1 .5-.5z"
                    />
                    <path
                      d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z"
                    />
                  </svg>
                </button>

                <!-- Download Source Button -->
                <button
                  class="btn action-btn"
                  title="Download Source"
                  (click)="downloadSource(item._id)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#000000"
                    viewBox="0 0 16 16"
                  >
                    <!-- Document body -->
                    <path
                      d="M4 0h5.5L13 3.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
                    />
                    <!-- Folded corner -->
                    <path
                      d="M9.5 0v3H13L9.5 0z"
                      fill="currentColor"
                      opacity="0.5"
                    />
                    <!-- Down arrow (white, embedded in doc) -->
                    <g fill="white">
                      <rect
                        x="7.25"
                        y="5.5"
                        width="1.5"
                        height="4.5"
                        rx="0.5"
                      />
                      <polygon points="6,9.5 8,12 10,9.5" />
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Toast Container -->

